module.exports = __webpack_public_path__ + "static/media/SSES.44f4ff95.png";